<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BillingCmlMasterCustomer",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  